
import React from "react";
import { Award } from "lucide-react";
import { motion } from "framer-motion";

interface PremiumBadgeProps {
  karmaLevel: number;
}

const PremiumBadge = ({ karmaLevel }: PremiumBadgeProps) => {
  if (!karmaLevel || karmaLevel < 3) return null;
  
  return (
    <motion.div 
      className="bg-yellow-50 border border-yellow-100 rounded-lg p-4 flex items-center gap-3"
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 0.5, duration: 0.5, type: "spring" }}
    >
      <Award className="h-6 w-6 text-yellow-500" />
      <div>
        <h3 className="font-medium">Premium Member</h3>
        <p className="text-sm text-muted-foreground">You've unlocked premium features with your karma level!</p>
      </div>
    </motion.div>
  );
};

export default PremiumBadge;
